import { render, staticRenderFns } from "./eComplaintManagers.vue?vue&type=template&id=bcd90294"
import script from "./eComplaintManagers.vue?vue&type=script&lang=js"
export * from "./eComplaintManagers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports